import { COMMON_CHUNK_NAME } from '../../../../../const/generator';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IProjectInfo,
} from '../../../../../types';

const pluginFactory: BuilderComponentPluginFactory<unknown> = () => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IProjectInfo;
    let hasFusion=false;
    ir.packages.forEach((packageInfo) => {
      console.log("dependencies.................")
      console.log(packageInfo.package)
      if("@alifd/fusion-ui"===packageInfo.package){
        hasFusion=true;
      }
    });
    if(hasFusion){
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.CSS,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        @import '~antd/dist/antd.css';
        @import '~@alifd/next/dist/next.css';
        @import "~@alifd/pro-layout/dist/AlifdProLayout.css";
      `,
        linkAfter: [],
      });
    }else {
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.CSS,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        @import '~antd/dist/antd.css';
      `,
        linkAfter: [],
      });
    }

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.CSS,
      name: COMMON_CHUNK_NAME.StyleCssContent,
      content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
      linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport],
    });

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.CSS,
      name: COMMON_CHUNK_NAME.StyleCssContent,
      content: ir.css || '',
      linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport],
    });

    return next;
  };
  return plugin;
};

export default pluginFactory;
